// cores
import React from "react"
import classNames from "classnames"
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"
import { Redirect } from "react-router-dom"

import { withTranslation } from "react-i18next"
import { compose } from "redux"

// UI components
import Button from "components/CustomButtons/Button"
import Table from "components/Table/Table"
import GridItem from "components/Grid/GridItem"
import GridContainer from "components/Grid/GridContainer"
import Pagination from "components/Pagination/Pagination.js"
import Badge from "components/Badge/Badge.js"
import Input from "components/CustomInput/CustomInput.js"
import Tooltip from "@material-ui/core/Tooltip"

// Icons
import SearchIcon from "@material-ui/icons/Search"
import ClearAllIcon from "@material-ui/icons/ClearAll"
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos"
import Check from "@material-ui/icons/Check"
import AddIcon from "@material-ui/icons/Add"
import RemoveIcon from "@material-ui/icons/Remove"

import { Dropdown, Dimmer, Loader, Segment, Label } from "semantic-ui-react"

// Modal Components
import Zoom from "@material-ui/core/Zoom"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import DialogContent from "@material-ui/core/DialogContent"
import DialogActions from "@material-ui/core/DialogActions"

// libs
import Config from "config"
import axios from "axios"
import { fnumber, formatDateTime } from "components/Helper"
import GSearchActions from "components/GSearchActions.js"
import moment from "moment"
import secureStorage from "libs/secureStorage"

// styles
import style from "assets/jss/material-kit-pro-react/views/contactUsStyle.js"

const styles = (theme) => ({
	...style,
})

const CustomTransition = React.forwardRef(function Transition(props, ref) {
	return <Zoom ref={ref} {...props} />
})

class BillingUser extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			selectedUser: null,
			// paging states >>
			rowsPerPage: 15,
			currentPage: 1,
			totalPages: 0,
			totalData: 0,
			rows: [],
			//<<pagin states
			startDate: moment().startOf("day"),
			endDate: moment().endOf("day"),

			selectedProducts: [],
			products: [],

			selectedCategories: [],
			categories: [],

			keyword: "",
			isLoading: false,

			mutation: "",
			buttonTransferDisabled: false,

			salesId: "",
			transferPayload: "",

			confirmShow: false,
			modalShow: false,
			modalTitle: "",
			modalBody: "",
		}
	}

	componentDidMount() {
		this.loadProduct()

		this.loadBilling()
	}

	loadBilling = (params) => {
		const userId = this.props.match.params.userId
		// console.log(this.props.match.params)
		this.setState({ isLoading: true })
		const payload = {
			userId,
			startDate: params && params.startDate ? params.startDate : this.state.startDate,
			endDate: params && params.endDate ? params.endDate : this.state.endDate,
			// paging payload >>
			currentPage: params && params.currentPage ? params.currentPage : 1,
			rowsPerPage: params && params.rowsPerPage ? params.rowsPerPage : this.state.rowsPerPage,
			// << paging payload
			products: this.state.selectedProducts && this.state.selectedProducts.length > 0 && this.state.selectedProducts,
			// selectedUser : this.props.location.selectedUser
			keyword: params && params.keyword ? params.keyword : this.state.keyword,
		}

		axios
			.post(Config.ApiUrl + "/user/billing", payload)
			.then((res) => {
				// console.log(res.data)
				this.setState({
					// name: res.data.name,
					selectedUser: res.data.selectedUser,
					rows: res.data.billings,
					totalPages: res.data.totalPages,
					totalData: res.data.totalData,
					startDate: payload.startDate,
					endDate: payload.endDate,
					isLoading: false,
				})
			})
			.catch((error) => {
				this.setState({ isLoading: false })
				console.log(error)
			})
	}

	loadProduct() {
		axios
			.post(Config.ApiUrl + "/product/dropdown")
			.then((res) => {
				this.setState({ products: res.data })
			})
			.catch((error) => {
				console.log(error)
			})
	}

	handleConvert = (e) => {
		const valStr = e.target.value.replace(/\./g, "")
		let value = isNaN(valStr) || valStr === "" ? 0 : parseInt(valStr)
		if (value < 0) value = 0
		this.setState({ mutation: fnumber(value) })
	}

	handleTransfer = (action) => {
		if (this.state.mutation) {
			const amount = parseInt(this.state.mutation.replace(/\./g, ""))
			// const userId = this.props.match.params.userId
			if (amount > 0) {
				const transferPayload = {
					selectedUser: this.state.selectedUser,
					amount: action === "transfer" ? amount : parseInt(amount * -1),
					action,
				}
				this.setState({
					buttonTransferDisabled: false,
					transferPayload,
					modalShow: true,
					// modalTitle: `Add to ${this.state.name}`.toUpperCase(),
					modalTitle: `${action} ${action === "transfer" ? "to" : "from"} ${
						this.state.selectedUser.name
					}`.toUpperCase(),
					modalBody: "transfer",
				})
			}
		}
	}

	transferAction = () => {
		return (
			<div>
				<Button onClick={() => this.setState({ modalShow: false })} color="warning" round>
					Cancel
				</Button>
				<Button onClick={this.setBilling} color="success" round disabled={this.state.buttonTransferDisabled}>
					{this.state.transferPayload.action}
				</Button>
			</div>
		)
	}

	setBilling = () => {
		this.setState({ buttonTransferDisabled: true })
		const payload = this.state.transferPayload
		payload.salesId = this.state.salesId

		axios
			.post(`${Config.ApiUrl}/user/billing/set`, payload)
			.then((res) => {
				this.setState(
					{
						salesId: "",
						mutation: "",
						modalShow: false,
						buttonTransferDisabled: false,
					},
					() => {
						this.loadBilling()
					}
				)
			})
			.catch((err) => {
				this.setState(
					{
						buttonTransferDisabled: false,
						salesId: "",
					},
					() => {
						alert(err.respose ? err.respose.data : "Server Internal Error")
					}
				)
			})
	}

	transferBody = () => {
		return (
			<GridContainer justify="center">
				<GridItem xl={12} lg={12} md={12} sm={12} xs={12}>
					<Input
						labelText="salesId"
						id="salesId"
						formControlProps={{
							fullWidth: true,
						}}
						inputProps={{
							placeholder: "Sales ID",
							value: this.state.salesId,
							onChange: (e) => {
								this.setState({ salesId: e.target.value })
							},
							onKeyDown: (e) => {
								if (e.key === "Enter") {
									this.setBilling(e)
								}
							},
						}}
					/>
				</GridItem>
			</GridContainer>
		)
	}

	render() {
		// const userId = this.props.match.params.userId && parseInt(this.props.match.params.userId)
		const { classes, t } = this.props
		const user = secureStorage.getItem("user")
		return (
			<div className={classNames(classes.main, classes.mainRaised)}>
				<div className={classes.contactContent}>
					<div className={classes.container}>
						<GridContainer justify="center">
							<GridItem xl={12} lg={12} md={12} sm={12} xs={12}>
								<GridContainer justify="center">
									<GridItem xl={3} lg={3} md={3} sm={12} xs={12} className={classes.grid}>
										<Button
											onClick={(e) => {
												if (this.props.location && this.props.location.state && this.props.location.state.backPayload) {
													secureStorage.setItem("backPayload", this.props.location.state.backPayload)
												}
												this.props.history.goBack()
											}}
											color="danger"
											round
										>
											<ArrowBackIosIcon />
											{t("back")}
										</Button>
										<br />
										<Label size="big">{t("BILLING")}</Label>
										{this.state.selectedUser && (
											<Label size="medium" color="orange">
												{this.state.selectedUser && this.state.selectedUser.name}
											</Label>
										)}
									</GridItem>
									<GridItem xl={9} lg={9} md={9} sm={12} xs={12}>
										<GridContainer justify="center">
											<GridItem xl={12} lg={12} md={12} sm={12} xs={12}>
												<GSearchActions
													onChange={({ startDate, endDate }) => this.setState({ startDate, endDate })}
													onSubmit={this.loadBilling}
												/>
											</GridItem>
										</GridContainer>
									</GridItem>
								</GridContainer>
							</GridItem>
							{/* Filter Item & Keyword */}
							<GridItem justify="center" xl={12} lg={12} md={12} sm={12} xs={12}>
								{/* Filter Item & Keyword */}
								<GridContainer justify="center">
									<GridItem xl={3} lg={3} md={3} sm={12} xs={12}>
										<Dropdown
											style={{ marginTop: 25 }}
											placeholder="ITEM"
											fluid
											multiple
											search
											selection
											value={this.state.selectedProducts}
											onChange={(e, { value }) => {
												this.setState({
													selectedProducts: value,
													selectedCategories: [],
												})
											}}
											options={this.state.products.map((item, index) => ({
												key: item.id,
												text: item.name,
												value: item.id,
											}))}
										/>
									</GridItem>

									<GridItem xl={4} lg={4} md={4} sm={12} xs={12}>
										<Input
											labelText={t("search")}
											id="keyword"
											formControlProps={{
												fullWidth: true,
											}}
											inputProps={{
												placeholder: "IDPEL / TRID / REFID",
												value: this.state.keyword,
												onChange: (e) => {
													this.setState({ keyword: e.target.value })
												},
												onKeyPress: (e) => {
													if (e.key === "Enter") {
														this.setState({ keyword: e.target.value })
														this.loadBilling({ keyword: e.target.value })
													}
												},
											}}
										/>
									</GridItem>

									{user.userTypeId === 1 && (
										<>
											<GridItem xl={2} lg={2} md={2} sm={7} xs={12}>
												<Input
													labelText={"Transfer"}
													id="mutation"
													formControlProps={{
														fullWidth: true,
													}}
													inputProps={{
														placeholder: "Masukkan Jumlah saldo",
														value: this.state.mutation,
														onChange: this.handleConvert,
													}}
												/>
											</GridItem>
											<GridItem xl={2} lg={2} md={5} sm={5} xs={12}>
												<span>
													<div className={classNames(classes.buttonGroup, classes.buttons)}>
														<Tooltip
															id="tooltip-search"
															title="Tambah Billing"
															placement="top"
															classes={{ tooltip: classes.tooltip }}
														>
															<Button
																color="success"
																size="sm"
																round
																onClick={() => this.handleTransfer("transfer")}
																className={classes.firstButton}
															>
																<AddIcon />
															</Button>
														</Tooltip>
														<Tooltip
															id="tooltip-clear"
															title="Tarik Saldo"
															placement="top"
															classes={{ tooltip: classes.tooltip }}
														>
															<Button
																color="danger"
																size="sm"
																round
																onClick={() => this.handleTransfer("deduct")}
																className={classes.lastButton}
															>
																<RemoveIcon />
															</Button>
														</Tooltip>
													</div>
												</span>
											</GridItem>
										</>
									)}
								</GridContainer>
							</GridItem>
							<GridItem xl={12} lg={12} md={12} sm={12} xs={12}>
								<Segment vertical>
									<Dimmer active={this.state.isLoading} inverted>
										<Loader />
									</Dimmer>
									<Table
										sortable
										stickyHead
										stickyFoot
										striped
										tableHead={[
											"#",
											"TRXID",
											"REFID",
											"IDPEL",
											t("Product"),
											t("Date"),
											t("Remark"),
											t("Amount"),
											"Total Nominal",
										]}
										tableData={this.state.rows.map((row, index) => [
											index +
												1 +
												(isNaN(this.state.rowsPerPage) ? 0 : (this.state.currentPage - 1) * this.state.rowsPerPage),
											row.TrSale && row.TrSale.id ? row.TrSale.id.toString().padStart(8, 0) : "-",
											row.TrSale && row.TrSale.refId ? row.TrSale.refId.toString().padStart(8, 0) : "-",
											row.TrSale && row.TrSale.customerCode ? row.TrSale.customerCode : "-",
											row.TrSale && row.TrSale.Product && row.TrSale.Product.name ? row.TrSale.Product.name : "-",
											formatDateTime(row.createdAt),
											row.remark ? row.remark : "-",
											fnumber(row.amount),
											fnumber(row.currAmount),
										])}
										textAlignCells={["right", "right"]}
										textAlignForCells={[7, 8]}
										textAlignHeaders={["right", "right"]}
										textAlignForHeaders={[7, 8]}
										rawData={this.state.rows}
										onSort={(data) => this.setState({ rows: data })}
									/>
								</Segment>
							</GridItem>
							<GridItem xl={12} lg={12} md={12} sm={12} xs={12} className={classes.grid}>
								<div className={classes.justifyContentCenter}>
									<Pagination
										totalButton={7}
										totalPages={this.state.totalPages}
										totalData={this.state.totalData}
										currentPage={this.state.currentPage}
										onChangePage={(currentPage) => {
											if (currentPage !== this.state.currentPage) {
												this.setState({ currentPage })
												this.loadBilling({ currentPage })
											}
										}}
										// pages={[
										// 	...this.paginationButton(),
										// ]}
										rowsPerPage={[5, 15, 25, "All"]}
										defaultRowsPerPage={this.state.rowsPerPage}
										onChangeRowsPerPage={(value) => {
											console.log(value)
											this.setState({ rowsPerPage: value, currentPage: 1 })
											this.loadBilling({ rowsPerPage: value, currentPage: 1 })
										}}
									/>
								</div>
							</GridItem>
						</GridContainer>

						{/* Modal >> */}
						<Dialog
							classes={{
								root: classes.modalRoot,
								paper: classes.modal,
							}}
							open={this.state.modalShow}
							TransitionComponent={CustomTransition}
							keepMounted
							//onClose={() => this.setState({successModal: false})}
							aria-labelledby="classic-modal-slide-title"
							aria-describedby="classic-modal-slide-description"
						>
							<DialogTitle id="classic-modal-slide-title" disableTypography className={classes.modalHeader}>
								<h4 className={classes.modalTitle}>{this.state.modalTitle}</h4>
							</DialogTitle>
							<DialogContent id="classic-modal-slide-description" className={classes.modalBody}>
								{this.state.modalBody === "transfer" && this.transferBody()}
							</DialogContent>
							<DialogActions className={classes.modalFooter}>
								{this.state.modalBody === "transfer" && this.transferAction()}
							</DialogActions>
						</Dialog>
						{/* << Modal */}
					</div>
				</div>
			</div>
		)
	}
}

BillingUser.propTypes = {
	classes: PropTypes.object.isRequired,
}

export default compose(withTranslation(), withStyles(styles))(BillingUser)
